import { render } from "./TreeChart.vue?vue&type=template&id=bb83325c&scoped=true"
import script from "./TreeChart.vue?vue&type=script&lang=js"
export * from "./TreeChart.vue?vue&type=script&lang=js"

import "./TreeChart.vue?vue&type=style&index=0&id=bb83325c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb83325c"]])

export default __exports__